<template>
    <div>
        <div class="header-container">
            <div class="header-top">
                <h2 class="logo">
                    <i href="javascript:;" title="金榜志愿通" @click="refreshHtml">
                    <img src="../assets/images/logo.jpg" style="width:85%;height:85%;"/>
                    </i>
                </h2>
            <!-- <div class="header-md">
                <el-input v-model="searchContent" placeholder="查大学/查专业/搜问答" style="width:400px;">
                    <el-button slot="append">搜索</el-button>
                </el-input>
            </div> 
            {{gkYear2}}年-->
            <div style="display: block;margin-left: 506px;">
                <div style="font-size:15px;color:#ff9966;font-weight:bold;"
                v-if="isShowGKMsg1">
                距离{{gkYear}}年高考还有 <span style="color:blue;font-size:20px;">{{days}} </span>天
                </div>
                <div style="font-size:15px;color:#ff861a;font-weight:bold;
                width: 260px;
                "
                v-else-if="isShowGKMsg2">
                距离{{gkYear2}}年高考志愿填报还有 <span style="color:blue;font-size:20px;">{{days2}} </span>天
                </div>
                <div style="font-size:15px;color:#ff861a;font-weight:bold;
                width: 260px;
                " v-else-if="isShowGKMsg3">
                今天是高考志愿填报第 <span style="color:blue;font-size:20px;">{{days3}} </span>天
                </div>
                <div v-else-if="isShowGKMsg4"
                 style="font-size:15px;color:#ff9966;font-weight:bold;">
                距离{{gkYear3}}年高考还有 <span style="color:blue;font-size:20px;">{{days4}} </span>天
                </div>
            </div>
            <div class="header-bottom">
                <!-- <el-select v-model="provinceId" style="width:100px;" size="small"></el-select>-->
                <!-- <el-button type="primary" size="small" style="margin-left:15px;">登录</el-button>-->
                <!-- <el-button type="primary" size="small">注册</el-button> -->
                 <el-button type="primary" size="small" @click="goToMain">首页</el-button>
            </div>
            </div>
            <div class="header-nav">
                <!-- <ul class="nav-item">
                <li :class="{current: $route.path.includes('/main/home')}"><router-link  to="/main/home" >首页</router-link></li>
                <li :class="{current: $route.path.includes('/zypg')}">
                    <router-link to="/zypg" >志愿评估</router-link>
                </li>
                <li :class="{current: $route.path.includes('/schoolRecommend')}"><router-link to="/schoolRecommend" ><span @click="clearYxtj">院校推荐</span></router-link></li>
                <li :class="{current: $route.path.includes('/schoolfinder')}"><router-link to="/schoolfinder"><span @click="clearYxcx">院校查询</span></router-link></li>
                <li :class="{current: $route.path.includes('/majorquery')}"><router-link to="/majorquery">专业查询</router-link></li>
                <li :class="{current: $route.path.includes('/datahome')}"><router-link to="/datahome">数据查询</router-link></li>
                <li :class="{current: $route.path.includes('/me')}"><router-link to="/me">用户中心</router-link></li>
                <li :class="{current: $route.path.includes('/buyindex')}" ><router-link to="/buyindex" >在线购买</router-link></li>
                <li :class="{current: $route.path.includes('/qjPlan')}"><router-link to="/qjPlan"> 强基计划</router-link></li>
                <li><a href="http://www.zy1dt.cn" target="_blank"><i class="el-icon-s-promotion"></i>艺考系统入口</a></li>
                </ul> -->
                <ul class="nav-item">
                <li :class="{current: $route.path.includes('/main/home')}"><router-link  to="/main/home" >首页</router-link></li>
                <li @click="showDialog">
                    <span>高考选科</span>
                    <span class="el-icon-caret-bottom"></span>
                </li>
                <li @click="showDialog">
                    <span>志愿推荐</span>
                </li>
                <li @click="showDialog">
                    <span>志愿评估</span>
                </li>
                <li @click="showDialog">
                    <span>院校查询</span>
                </li>
                <li @click="showDialog">
                    专业查询
                </li>
                <li :class="{current: $route.path.includes('/main/me')}">
                    <router-link to="/main/me">用户中心</router-link>
                </li>
                <li :class="{current: $route.path.includes('/main/buyindex')}">
                    <router-link to="/main/buyindex">在线购买</router-link>
                </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
// icon="el-icon-search"
import {mapState} from 'vuex';
export default {
data(){
    return{
        searchContent:"",
        provinceId:"43",
        gkYear:"",
        days:"",
        gkYear2:"",
        gkYear3:"",
        days2:"",
        days3:"",
        days4:"",
        isShowGKMsg1:false,
        isShowGKMsg2:false,
        isShowGKMsg3:false,
        isShowGKMsg4:false,
        hours:"",
        minutes:"",
        second:"",
        gkTimer:null
    };
},
methods:{
    refreshHtml(){
        let href="";
        if (location.href.indexOf("#") !== -1) {
            href = location.href.substring(0, location.href.indexOf("#"));
        }
        location.href =href;
    },
    clearYxcx(){},
    clearYxtj(){},
    showDialog(){
        this.$message({message:"欢迎加入金榜志愿通会员",type:"warning"});
    },
    setGkTimer(){
        this.gkTimer=setInterval(() => {
        const currentYear=new Date().getFullYear();
        const gaokaoDate=new Date(currentYear,5,7);
        const tianbaoDate=new Date(currentYear,5,26);
        const editSchoolDate=new Date(currentYear,6,1);
        if(new Date()<gaokaoDate){
            this.isShowGKMsg1=true;
            this.isShowGKMsg2=false;
            this.isShowGKMsg3=false;
            this.isShowGKMsg4=false;
            this.gkYear=gaokaoDate.getFullYear();
            // gaokaoDate.setFullYear(currentYear+1);
        }else if(new Date()>=gaokaoDate&&new Date()<=tianbaoDate){
            this.isShowGKMsg1=false;
            this.isShowGKMsg2=true;
            this.isShowGKMsg3=false;
            this.isShowGKMsg4=false;
            this.gkYear2=currentYear;
        }else if(new Date()>tianbaoDate&&new Date()<=editSchoolDate){
            this.isShowGKMsg1=false;
            this.isShowGKMsg2=false;
            this.isShowGKMsg3=true;
            this.isShowGKMsg4=false;
            const dqMonth=new Date().getMonth()+1;
            const dqDay=new Date().getDate();
            const dqDate=new Date(currentYear,dqMonth-1,dqDay);
            const chaDays=Math.abs(Math.ceil((editSchoolDate-dqDate)/(1000*60*60*24)));
            const showTxt=6-chaDays;
            this.gkYear2=currentYear;
            this.days3=showTxt;
        }else if(new Date()>editSchoolDate&&new Date().getMonth()==6
        &&new Date().getDate()==1){
            this.isShowGKMsg1=false;
            this.isShowGKMsg2=false;
            this.isShowGKMsg3=true;
            this.isShowGKMsg4=false;
            const dqMonth=new Date().getMonth()+1;
            const dqDay=new Date().getDate();
            const dqDate=new Date(currentYear,dqMonth-1,dqDay);
            const chaDays=Math.abs(Math.ceil((editSchoolDate-dqDate)/(1000*60*60*24)));
            console.log(editSchoolDate);
            console.log(dqDate);
            console.log(chaDays);
            const showTxt=6-chaDays;
            this.gkYear2=currentYear;
            this.days3=showTxt;
        }else if(new Date()>editSchoolDate&&(new Date().getMonth()>6
        ||(new Date().getMonth()==6
        &&new Date().getDate()>1))){
            gaokaoDate.setFullYear(currentYear+1);
            this.gkYear3=currentYear+1;
            this.isShowGKMsg1=false;
            this.isShowGKMsg2=false;
            this.isShowGKMsg3=false;
            this.isShowGKMsg4=true;
            this.days4=Math.ceil((Math.abs(new Date()-gaokaoDate))/(1000*60*60*24));
        }
        const now=new Date();
        const cha=gaokaoDate-now;
        const cha2=tianbaoDate-now;
        if(cha>=0){
            this.days=Math.ceil(cha/(1000*60*60*24));
            // this.hours=Math.floor(cha%(1000*60*60*24)/(1000*60*60));
            // this.minutes=Math.floor(cha%(1000*60*60)/(1000*60));
            // this.second=Math.floor(cha%(1000*60)/1000);
        }else if(cha2>=0){
            this.days2=Math.ceil(cha2/(1000*60*60*24));
        }
    }, 1000);
    },
    goToMain(){
        this.$router.push("/main/home");
    },
},
computed:{
    ...mapState(["userInfo"])
},
mounted(){
    this.setGkTimer()
},
beforeDestroy(){
    clearInterval(this.gkTimer);
}
};
</script>
<style scoped lang="less">
.header-container{
    .header-top{
        display:flex;
        justify-content:space-between;
        align-items:center;
        width:1100px;
        height:130px;
        margin:0 auto;
        position:relative;
    }
    .header-md{
        flex:1;
        display:flex;
        justify-content:flex-start;
        align-items:center;
        .md-change{
            flex: 1;
            // margin-left: 65px;
            margin-left:20px;
            padding-top: 12px;
            box-sizing: border-box;
        }
        .header-user{
            flex: 1;
            margin-right: 10px;
            text-align: right;
            font-size: 14px;
        }
        .score{
            color:#f56c6c;
        }
    }
    .header-rt{
        width: 160px;
        text-align: left;
    }
    .header-nav{
        width:100%;
        height:40px;
        background-color:#409EFF;
        .nav-item{
            // min-width:1200px;
            max-width: 1200px;
            display:flex;
            justify-content:center;
            align-items:center;
            flex-flow:nowrap;
            color:#ffffff;
            li{
                flex-basis: 120px;
                height:40px;
                line-height:40px;
                cursor:pointer;
                text-align:center;
                list-style:none;
                a{
                    display:block;
                    color:#ffffff;
                    text-decoration:none;
                    &:-webkit-any-link{
                        text-decoration:none;
                    }
                    .router-link-active{
                        text-decoration:none;
                    }
                }
            }
            li.current{
                    background-color:#0479f5;
                }
        }
    }
}
h1,h2,h3,h4,h5,h6{
    margin: 0 !important;
    font-weight: 700 !important;
}
</style>
